export default __webpack_public_path__ + "static/media/no_commit.fcb1bb80.svg";